import DataSheetBase from './DataSheetBase.js';

export default class DataSheet_localizationSheet extends DataSheetBase {

  constructor(id, updateCb) {
    super(id, updateCb);
    this.requestedKeyPath = "";  // this value can be specified in the React Studio data sheet UI
  }

  makeDefaultItems() {
    // eslint-disable-next-line no-unused-vars
    let key = 1;
    // eslint-disable-next-line no-unused-vars
    let item;
    
    item = {};
    this.items.push(item);
    item['key'] = "drinkitem_text_371725";
    item['en'] = "(Drink name)";
    
    item = {};
    this.items.push(item);
    item['key'] = "drinkitem_drinknamecopy_726857";
    item['en'] = "(Drink description)";
    
    item = {};
    this.items.push(item);
    item['key'] = "drinkitem_drinkdescriptioncopy_512016";
    item['en'] = "(Drink price)";
    
    item = {};
    this.items.push(item);
    item['key'] = "adddrink_field_521192";
    item['en'] = "Drink name";
    
    item = {};
    this.items.push(item);
    item['key'] = "adddrink_fieldcopy_427507";
    item['en'] = "Price";
    
    item = {};
    this.items.push(item);
    item['key'] = "adddrink_textarea_810693";
    item['en'] = "Description";
    
    item = {};
    this.items.push(item);
    item['key'] = "adddrink_button_713859";
    item['en'] = "Save";
    
    item = {};
    this.items.push(item);
    item['key'] = "adddrink_validator_677896";
    item['en'] = "*Check the form fields!";
    
    item = {};
    this.items.push(item);
    item['key'] = "code_text_92733";
    item['en'] = "{ \n apiKey: \"AIzaSyDW0YKFeTCdDQjj8I7q4K8ro4Z7MZ5gTuQ\",\n    authDomain: \"slackclone-c5e5d.firebaseapp.com\",\n    databaseURL: \"https://slackclone-c5e5d.firebaseio.com\",\n    projectId: \"slackclone-c5e5d\",\n    storageBucket: \"slackclone-c5e5d.appspot.com\",\n    messagingSenderId: \"427387001743\",\n    appId: \"1:427387001743:web:fba0af9602bffc6bc489fa\"\n}";
    
    item = {};
    this.items.push(item);
    item['key'] = "drawer_button_726183";
    item['en'] = "New button";
    
    item = {};
    this.items.push(item);
    item['key'] = "drawer_buttoncopy_452429";
    item['en'] = "New button";
    
    item = {};
    this.items.push(item);
    item['key'] = "screen7_text_456512";
    item['en'] = "Test screen";
    
    item = {};
    this.items.push(item);
    item['key'] = "mydrinks_button_934402";
    item['en'] = "New button";
    
    item = {};
    this.items.push(item);
    item['key'] = "component2_text_663523";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "component2_text_659298";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "mydrinks_button_342636";
    item['en'] = "Email test";
    
    item = {};
    this.items.push(item);
    item['key'] = "email_button_537592";
    item['en'] = "Send";
    
    item = {};
    this.items.push(item);
    item['key'] = "userscore_text_276584";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "userscore_textcopy_909438";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "comp1_text_819561";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "comp1_textcopy_146350";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "mydrinks_button2_108706";
    item['en'] = "Scores";
    
    item = {};
    this.items.push(item);
    item['key'] = "userscore_button_333558";
    item['en'] = "Refresh";
    
    item = {};
    this.items.push(item);
    item['key'] = "userscore_button_265615";
    item['en'] = "New button";
    
    item = {};
    this.items.push(item);
    item['key'] = "addvalue_text_668621";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "addvalue_textcopy_797288";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "addvalue_textcopy2_270143";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "addvalue_button_872365";
    item['en'] = "Add value to price";
    
    item = {};
    this.items.push(item);
    item['key'] = "mydrinks_buttoncopy_861333";
    item['en'] = "Raise price";
    
    item = {};
    this.items.push(item);
    item['key'] = "componentfavorite_text_772386";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "mydrinks_buttoncopy2_513521";
    item['en'] = "Favs";
    
    item = {};
    this.items.push(item);
    item['key'] = "componentfavorite_textcopy_45392";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "drinkitem_text_174248";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "component1_text_584521";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "webcontent_field_278225";
    item['en'] = "URL";
    
    item = {};
    this.items.push(item);
    item['key'] = "componentfavorite_textcopy2_704009";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "favorite_text_505491";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "favorite_textcopy_419461";
    item['en'] = "New text. Double-click to edit";
  }

  getStringsByLanguage = () => {
    let stringsByLang = {};
    for (let row of this.items) {
      const locKey = row.key;
      for (let key in row) {
        if (key === 'key')
          continue;
        let langObj = stringsByLang[key] || {};
        langObj[locKey] = row[key];
        stringsByLang[key] = langObj;
      }
    }
    return stringsByLang;
  }

}
